
import './App.css';
import Footer from './components/Footer';
// import Header from './components/Header';
import LandingPage from './components/LandingPage';
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import ProductDetail from './components/ProductDetail';
import PrivateAdminDashboard from './components/PrivateAdminDashboard';
import AdminDashboard from './components/AdminDashborad';
import AdminLogin from './components/AdminLogin';
import AdminSignup from './components/AdminSignUp';
import AdminForgotPassword from './components/AdminForgotPassword';
import AdminResetPassword from './components/AdminResetPassword';
import ScrollToTop from './components/ScrollToTop';
// import Menu from './components/Menu';
// import CompanyCertificate from './components/CompanyCertificate';
import CategoryPage from './components/CategoryPage';
import AllProductsPage from './components/AllProductsPage';
// import MenuItem2 from './components/MenuItem2';
// import UpdateProductKeys from './components/UpdateProductKeys';
// import DeleteProductKey from './components/DeleteProductKey';
// import CurrencyToggle from './components/CurrencyToggle';
// import styled from 'styled-components';

import SearchPage from './components/SearchPage';
import ContactForm from './components/Contactus';
import ComingSoon from './components/ComingSoon';
import AppUpdate from './components/AppUpdate';
import AccountInfoPage from './components/AccountInfoPage';
import PaymentInProgressModal from './components/PaymentInProgressModal';
import { useSelector } from 'react-redux';
import Header2 from './components/Header2';
import TermsAndConditions from './components/TermsAndConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import VirtualAssistantPromo from './components/VAPromoPage';



function App() {


const paymentSession = useSelector(state=>state.paymentSession);
// const paymentSession=true

  return (
   <BrowserRouter>
   <ScrollToTop/>
   {/* <Menu/> */}
   <AppUpdate/>
   {/* <MenuItem2/> */}
   {/* <CurrencyToggle/> */}
   {/* <DeleteProductKey/> */}
   {/* <UpdateProductKeys/> */}
    
   <Header2/>
      <Routes>
        <Route path='/' element={<LandingPage/>}/>
        <Route path='/productdetail/:id' element={<ProductDetail/>}/>
        <Route path='/dashboard' element={<PrivateAdminDashboard/>}>
          <Route path='' element={<AdminDashboard/>}/>
        </Route>
        <Route path='/login' element={<AdminLogin/>}/>
        <Route path='/adminsignup' element={<AdminSignup/>}/>
        <Route path='/adminforgotpassword' element={<AdminForgotPassword/>}/>
        <Route path='/adminresetpassword' element={<AdminResetPassword/>}/>
        <Route path='/category/:id' element={<CategoryPage/>}/>
        <Route path='/allproducts' element={<AllProductsPage/>}/>
        <Route path='/searchresults' element={<SearchPage/>}/>
        <Route path='/contactus' element={<ContactForm/>}/>
        <Route path='/comingsoon' element={<ComingSoon/>}/>
        <Route path='/accountinfo' element={<AccountInfoPage/>}/>
        <Route path='/termsandconditions' element={<TermsAndConditions/>}/>
        <Route path='/privacypolicy' element={<PrivacyPolicy/>}/>
        <Route path='/vapromo' element={<VirtualAssistantPromo/>}/>
      </Routes>
      {/* <CompanyCertificate/> */}
      {paymentSession&&<PaymentInProgressModal/>}
      <Footer/>
   </BrowserRouter>
  );
}

export default App;



// github push code
// dat 01/04/26
//time 5:55am
